module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "generated-style",
    attrs: {
      "id": "fm-12-tools-text"
    }
  }, [_c('p', {
    staticClass: "top-bar",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "generated-style-2"
  }, [_c('img', {
    staticClass: "generated-style-2",
    attrs: {
      "alt": "IcePops_TopBar_Green.gif",
      "src": "Images/IcePops_TopBar_Green_fmt.jpeg"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "recipe-heading",
    attrs: {
      "id": "toc-anchor",
      "xml:lang": "en-us"
    }
  }, [_vm._v("tools")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("At their simplest, ice pops require no special equipment. A bowl, a whisk, an ice pop mold, and a freezer are all you need to get started. Add a few simple tools, many of which you probably already own, and the possibilities are endless.")]), _vm._v(" "), _c('p', {
    staticClass: "method-subhead",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("kitchen tools")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("A blender or food processor are necessary for puréeing fresh fruit for fruit-based pops. If you don’t have these items, an old-fashioned food mill is an acceptable substitute. A small saucepan, a sieve, and a wooden spoon are recommended for making custard-based pops and other flavored pops in which solid ingredients need to be strained. Beyond these items, a good, sharp knife, a cutting board, and a sense of adventure are all that are required.")]), _vm._v(" "), _c('p', {
    staticClass: "method-subhead",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("molds & makers")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("You’ll be surprised at how many items in your household can be used for the purpose of molding and freezing pops. An ice cube tray, a nonstick muffin pan, or individual silicone cupcake cups all easily mold and release the frozen treats. Kitchen supply stores and online resources also carry a variety of specialty ice pop molds. These low-tech options range from traditional to whimsical shapes, including push-ups, stars, rockets, flowers, sailboats, and more. New technology also offers “instant” ice pop makers, which freeze pops in just minutes. Units such as the "), _c('span', {
    staticClass: "bold-link"
  }, [_c('a', {
    attrs: {
      "href": "http://www.williams-sonoma.com/products/zoku-quick-pop-maker/?",
      "target": "_blank"
    }
  }, [_vm._v("Zoku Quick Ice Pop Maker")])]), _vm._v(" feature a unit that is stored in the freezer, much like an ice cream maker, bringing new convenience to making pops at home.")]), _vm._v(" "), _c('p', {
    staticClass: "method-subhead",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("sticks & drip guards")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("While you can easily eat frozen treats on a plate with a fork or spoon, for many, the fact that the icy dessert is presented on a stick provides most of the appeal. Old-fashioned wooden sticks are found at kitchen supply and crafts stores. Many ice pop molds come with sticks, which are secured to the molds to stay upright as they freeze. Some also include drip guards, which offer a solution to the ice pop’s tendency to drip.")]), _vm._v(" "), _c('p', {
    staticClass: "bottom-bar",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "generated-style-2"
  }, [_c('img', {
    staticClass: "generated-style-2",
    attrs: {
      "alt": "IcePops_TopBar_Green.gif",
      "src": "Images/IcePops_TopBar_Green_fmt1.jpeg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-663d81d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/FM_12_Tools_text.vue
// module id = 78
// module chunks = 0